// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer_footer__0n6sz {
  padding: 5.2083333333vw 0 2rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}
.Footer_footer__0n6sz .Footer_logo__IJiJ1 {
  align-self: center;
}
.Footer_footer__0n6sz > span {
  align-self: center;
}
.Footer_footer__0n6sz > div:nth-of-type(2) {
  display: flex;
  justify-content: space-between;
  font-size: 1.6rem;
}
.Footer_footer__0n6sz > div:nth-of-type(2) > a {
  color: var(--grey);
}

@media (max-width: 800px) {
  .Footer_footer__0n6sz {
    padding: 5rem 0 2rem;
  }
  .Footer_footer__0n6sz .Footer_logo__IJiJ1 > svg {
    width: 6rem;
    height: 6rem;
  }
  .Footer_footer__0n6sz > div:nth-of-type(2) {
    flex-direction: column;
    text-align: center;
    gap: 0.8rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/common/Footer/Footer.module.scss"],"names":[],"mappings":"AAAA;EACC,8BAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AACD;AACC;EACC,kBAAA;AACF;AAGC;EACC,kBAAA;AADF;AAIC;EACC,aAAA;EACA,8BAAA;EACA,iBAAA;AAFF;AAGE;EACC,kBAAA;AADH;;AAOA;EACC;IACC,oBAAA;EAJA;EAOC;IACC,WAAA;IACA,YAAA;EALF;EASA;IACC,sBAAA;IACA,kBAAA;IACA,WAAA;EAPD;AACF","sourcesContent":[".footer {\n\tpadding: calc(100vw / 1920 * 100) 0 2rem;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 2rem;\n\n\t.logo {\n\t\talign-self: center;\n\t\t// color: var(--blue-dark);\n\t}\n\n\t& > span {\n\t\talign-self: center;\n\t}\n\n\t& > div:nth-of-type(2) {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tfont-size: 1.6rem;\n\t\t& > a {\n\t\t\tcolor: var(--grey);\n\t\t}\n\t}\n}\n\n// mobile\n@media (max-width: 800px) {\n\t.footer {\n\t\tpadding: 5rem 0 2rem;\n\n\t\t.logo {\n\t\t\t& > svg {\n\t\t\t\twidth: 6rem;\n\t\t\t\theight: 6rem;\n\t\t\t}\n\t\t}\n\n\t\t& > div:nth-of-type(2) {\n\t\t\tflex-direction: column;\n\t\t\ttext-align: center;\n\t\t\tgap: 0.8rem;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `Footer_footer__0n6sz`,
	"logo": `Footer_logo__IJiJ1`
};
export default ___CSS_LOADER_EXPORT___;
